export default "__VITE_ASSET__BmQsaY7___"